import { Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes } from "./public-routes";

const UnAuthApp = () => {
	return (
		<Routes>
			{publicRoutes}
			<Route path="*" element={<Navigate to="/" />} />
		</Routes>
	);
};

export default UnAuthApp;
